<template>
  <div class="header">
  </div>
</template>

<script lang="ts" setup>
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 48px;
  padding: 24px;

  @media (min-width: 374px) {
    padding-left: 32px;
    padding-right: 32px;
  }
  @media (min-width: 600px) {
    max-width: 600px;
    margin: 0 auto;
  }

}
</style>
